<ng-container *ngIf="!viewTimesheet">
    <table
        mat-table
        multiTemplateDataRows
        [dataSource]="datasource$"
        class="mat-elevation-z8 ppw-list"
        (mousedown)="$event.shiftKey ? $event.preventDefault() : null">
        <ng-container matColumnDef="name">
            <th #nameHeader mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let element">
                <div class="{{ element.indentLvl !== undefined ? 'row-indent-' + element.indentLvl : '' }}">
                    <div fxLayoutAlign="start center">
                        <mat-icon *ngIf="element.children">
                            {{ element.isExpanded ? 'expand_more' : 'chevron_right' }}
                        </mat-icon>
                        <mat-icon
                            [class]="element.colorByGroupBy ? element.colorByGroupBy : 'timesheet'"
                            class="margin-right"
                            [class.extra-margin-left]="!element.children">
                            {{ element.icon ? element.icon : 'description' }}
                        </mat-icon>
                        <span>{{
                            element.name
                                ? element.name
                                : element.employee.fullName +
                                  ' - ' +
                                  element.timesheetProject.clientName +
                                  ' - ' +
                                  element.timesheetProject.name
                        }}</span>
                    </div>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="sendInvoice">
            <th mat-header-cell *matHeaderCellDef>
                <span matTooltip="Invoice / send"> Inv. / Send </span>
            </th>
            <td mat-cell *matCellDef="let element">
                <div *ngIf="element.toInvoice !== undefined">
                    <mat-icon
                        class="material-icons"
                        [matTooltip]="element.toInvoice && !isViewByTag ? 'Invoice' : 'Do NOT invoice'"
                        [color]="element.toInvoice && !isViewByTag ? 'accent' : 'warn'">
                        {{ element.toInvoice && !isViewByTag ? 'done' : 'not_interested' }}
                    </mat-icon>
                    <mat-icon
                        class="material-icons"
                        [matTooltip]="element.sendToCustomer && !isViewByTag ? 'Send' : 'Do NOT send'"
                        [color]="element.sendToCustomer && !isViewByTag ? 'accent' : 'warn'">
                        {{ element.sendToCustomer && !isViewByTag ? 'send' : 'do_not_disturb_on' }}
                    </mat-icon>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">
                <mat-icon
                    *ngIf="element.state && element.state !== 0 && !isViewByTag"
                    matTooltip="Approved"
                    class="material-icons"
                    color="primary">
                    assignment_turned_in
                </mat-icon>
                <mat-icon
                    *ngIf="element.invoiced && element.state === 3 && !isViewByTag"
                    matTooltip="Invoiced"
                    class="material-icons"
                    color="primary">
                    euro_symbol
                </mat-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="HTC">
            <th mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="end center">
                    <span matTooltip="Hours to charge">HTC</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let element">
                <div fxLayoutAlign="end center">
                    {{ element.hoursToCharge }}
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="HNC">
            <th mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="end center">
                    <span matTooltip="Hours no charge">HNC</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let element" class="warn">
                <span fxLayoutAlign="end center">
                    {{ element.hoursNoCharge }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="HTT">
            <th mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="end center">
                    <span matTooltip="Hours total">HTT</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let element">
                <span fxLayoutAlign="end center">
                    {{ element.hoursTotal }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DTC">
            <th mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="end center">
                    <span matTooltip="Days to charge">DTC</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let element">
                <span fxLayoutAlign="end center">
                    {{ element.daysToCharge }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DNC">
            <th mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="end center">
                    <span matTooltip="Days no charge">DNC</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let element" class="warn">
                <span fxLayoutAlign="end center">
                    {{ element.daysNoCharge }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="DTT">
            <th mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="end center">
                    <span matTooltip="Days total">DTT</span>
                </div>
            </th>
            <td mat-cell *matCellDef="let element">
                <span fxLayoutAlign="end center">
                    {{ element.daysTotal }}
                </span>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr
            mat-row
            #timesheetRow
            *matRowDef="let element; let i = dataIndex; columns: displayedColumns"
            (click)="select(element, $event)"
            (dblclick)="dbClickShowTimesheet(element)"
            [class.detail-row-highlight]="element | highlight : selectedTimesheets"
            [class.latest-selected-timesheet]="i === latestSelectedTimesheetIndex"></tr>
    </table>
</ng-container>
